import { c as _c } from "react/compiler-runtime";
import { useMutation } from '@apollo/client/react';
import { developerGql } from '@nemlia/hasura-gql';
import { GetVariableType } from '@nemlia/hasura-schema';
const UPDATE_USER_LANGUAGE = developerGql(/* GraphQL */`
  mutation UPDATE_USER_LANGUAGE($id: uuid!, $user_language: String) {
    update_ta_user_by_pk(pk_columns: { id: $id }, _set: { user_language: $user_language }) {
      id
      user_language
    }
  }
`);
export const useUpdateUserLanguage = input => {
  const $ = _c(6);
  let t0;
  if ($[0] !== input) {
    t0 = {
      variables: input
    };
    $[0] = input;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const [mutate, t1] = useMutation(UPDATE_USER_LANGUAGE, t0);
  const {
    data,
    error
  } = t1;
  let t2;
  if ($[2] !== data || $[3] !== error || $[4] !== mutate) {
    t2 = {
      mutate,
      data,
      error
    };
    $[2] = data;
    $[3] = error;
    $[4] = mutate;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};